export default __webpack_public_path__ + "static/media/equity_db_icon.e5a7a8ba.svg";